<template>
  <div>
    <div>
      <div class="container">
        <page-title
          icon="fa fa-shopping-cart"
          main="Produtos"
          sub="Vincular Segmento e Cultura"
          :help="true" 
          titleHelp="Ajuda - Vincular Segmento e Cultura" 
      content="Página responsável por vincular Segmentos e Culturas
Para criação pressione o botão no canto superior direito 'Cadastrar Segmento'.
Para alteração pressione o botão no canto superior direito 'Editar Segmento'.
Para vincular segmentos e culturas pressione os botões de movimentação, localizados no meio da página entre Culturas e Hortifruti/Cereal.
"
        >
          <template v-slot:actions>
            <base-button
              type="neutral"
              @click="modals.modal0 = true"
              class="ml-3 mb-2"
              size="sm"
              >Novo Segmento</base-button
            >
            <base-button
              type="neutral"
              @click="modals.modal1 = true"
              class="ml-3 mb-2"
              size="sm"
              >Editar Segmento</base-button
            >
            <base-button
              type="danger"
              @click="modals.modal2 = true"
              class="ml-3 mb-2 deletSegment"
              size="sm"
              >Deletar Segmento</base-button
            >
          </template>
        </page-title>

        <modal :show.sync="modals.modal0" id="cadastrar-channel">
          <template slot="header">
            <h5 class="modal-title" id="exampleModalLabel">
              Cadastrar Segmento
            </h5>
          </template>
          <span slot="title">CANAL</span>
          <form role="form" @submit.prevent="saveChannel">
            <base-input group class="mb-3" :valid="true">
              <input
                type="text"
                class="form-control"
                placeholder="Nome do Segmento"
                v-model="channel.description"
                aria-label="Nome do Segmento"
              />
            </base-input>
          </form>
          <base-button type="secondary" @click="modals.modal0 = false"
            >Fechar</base-button
          >
          <base-button type="success" @click="saveChannel">Salvar</base-button>
        </modal>
        <modal :show.sync="modals.modal1" id="editar-channel">
          <template slot="header">
            <h5 class="modal-title" id="exampleModalLabel">Editar Segmento</h5>
          </template>
          <form role="form" @submit.prevent="editChannel">
            <base-input>
              <select
                class="form-control"
                v-model="channel.id"
                id="exampleFormControlSelect1"
              >
                <option value disabled selected
                  >Escolha o Segmento a ser editado</option
                >
                <option
                  v-for="channel in channels"
                  :key="channel.id"
                  :value="channel.id"
                  >{{ channel.description }}</option
                >
              </select>
            </base-input>
            <base-input group class="mb-3" :valid="true">
              <input
                type="text"
                class="form-control"
                placeholder="Nome do Segmento"
                v-model="channel.description"
                aria-label="Nome do Segmento"
              />
            </base-input>
          </form>
          <base-button type="secondary" @click="modals.modal1 = false"
            >Fechar</base-button
          >
          <base-button type="success" @click="editChannel">Salvar</base-button>
        </modal>
        <modal :show.sync="modals.modal2" id="excluir-channel">
          <template slot="header">
            <h5 class="modal-title" id="exampleModalLabel">Deletar Segmento</h5>
          </template>
          <form role="form" @submit.prevent="removeChannel">
            <base-input>
              <select
                class="form-control"
                v-model="channel.id"
                id="exampleFormControlSelect2"
              >
                <option value disabled selected
                  >Escolha o Segmento a ser excluido</option
                >
                <option
                  v-for="channel in channels"
                  :key="channel.id"
                  :value="channel.id"
                  >{{ channel.description }}</option
                >
              </select>
            </base-input>
          </form>
          <base-button type="secondary" @click="modals.modal2 = false"
            >Fechar</base-button
          >
          <base-button type="danger" @click="removeChannel(channel)"
            >Deletar</base-button
          >
        </modal>
        <modal :show.sync="modals.modal3" id="editar-culture">
          <template slot="header">
            <h5 class="modal-title" id="exampleModalLabel">Editar Cultura</h5>
          </template>
          <form role="form" @submit.prevent="editCulture">
            <base-input group class="mb-3" :valid="true">
              <input
                type="text"
                class="form-control"
                placeholder="Novo nome da Cultura"
                v-model="culture.description"
                aria-label="Novo nome da Cultura"
              />
            </base-input>
          </form>
          <base-button type="secondary" @click="modals.modal3 = false"
            >Fechar</base-button
          >
          <base-button type="success" @click="editCulture">Salvar</base-button>
        </modal>
        <modal :show.sync="modals.modal4" id="cadastrar-culture">
          <template slot="header">
            <h5 class="modal-title" id="exampleModalLabel">
              Cadastrar Cultura
            </h5>
          </template>
          <validation-observer ref="culture_observer">
            <form role="form" @submit.prevent="saveCulture">
              <base-input
                group
                class="mb-3"
                :valid="true"
                :required="true"
                type="text"
                placeholder="Nome da Cultura"
                v-model="culture.description"
                aria-label="Nome da Cultura"
              >
              </base-input>
            </form>
          </validation-observer>
          <base-button type="secondary" @click="modals.modal4 = false"
            >Fechar</base-button
          >
          <base-button type="success" @click="saveCulture">Salvar</base-button>
        </modal>
        <ul>
          <li v-for="(erro, index) of errors" :key="index">
            campo
            <b>{{ erro.field }}</b>
            - {{ erro.defaultMessage }}
          </li>
        </ul>
        <div class="form-row">
          <div class="container">
            <div class="card mt-2">
              <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li
                  class="nav-item"
                  @click="
                    setCultures('right', channel.id),
                      (channelSelected = channel.id)
                  "
                  v-for="(channel, index) of channels"
                  :key="channel.id"
                >
                  <a
                    :class="index == 0 ? 'nav-link active' : 'nav-link'"
                    v-bind:id="channel.id + '-tab'"
                    data-toggle="tab"
                    :href="`#channel-tab-${channel.id}`"
                    role="tab"
                    v-bind:aria-controls="channel.id"
                    aria-selected="true"
                    >{{ channel.description }}</a
                  >
                </li>
              </ul>
              <div class="tab-content" id="myTabContent">
                <div
                  :class="index == 0 ? 'tab-pane active' : 'tab-pane fade'"
                  v-for="(channel, index) of channels"
                  :key="channel.id"
                  :id="`channel-tab-${channel.id}`"
                  role="tabpanel"
                  v-bind:aria-labelledby="channel.id + '-tab'"
                >
                  <template>
                    <vue-list-picker
                      v-on:move-right="adicionaraochannel(channel.id, $event)"
                      v-on:move-left="adicionaraochannel(0, $event)"
                      v-on:move-all-right="
                        adicionaraochannel(channel.id, $event)
                      "
                      v-on:move-all-left="adicionaraochannel(0, $event)"
                      :left-items="cultures"
                      :right-items="rightItems"
                      :content-key="id"
                      :content-attr="description"
                      :title-left="'CULTURAS'"
                      :title-right="channel.description"
                      :content-class="'itensGrupos'"
                      :title-class="'tituloGrupos'"
                      :button-class="'btn btn-success button-class'"
                      :actions="true"
                      v-on:edit-item="editEvent"
                      v-on:delete-item="removeCulture"
                      :leftSearch="true"
                      v-on:search-action-left="searchEventLeft"
                      :rightSearch="true"
                      v-on:search-action-right="
                        searchEventRight($event, channel.id)
                      "
                      :show-button-left="true"
                      :button-left-value="'Nova Cultura'"
                      v-on:button-left="(modals.modal4 = true), (culture = {})"
                    />
                  </template>
                  <div class="row">
                    <div class="col-md-6 base-pagination-top">
                      <div slot="footer" class="py-4 justify-content-end">
                        <base-pagination
                          v-on:input="changePageLeft"
                          v-model="paginated_data_left['current']"
                          :total="paginated_data_left['count']"
                          :perPage="paginated_data_left['per_page']"
                        ></base-pagination>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div
                        slot="footer"
                        class="py-4 d-flex justify-content-end"
                      >
                        <base-pagination
                          v-on:input="changePageRight"
                          v-model="paginated_data_right['current']"
                          :total="paginated_data_right['count']"
                          :perPage="paginated_data_right['per_page']"
                        ></base-pagination>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
//import VueListPicker from "vue-list-picker";
import { showError } from "@/config/msg";
import PageTitle from "@/layouts/PageTitle";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";


// import Permissions from "../users/Permissions";
import Tab from "@/components/Tabs/Tab";
import Tabs from "@/components/Tabs/Tabs";
import VueListPicker from "@/components/Vue-list-picker/VueListPicker";
import { ValidationProvider, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
extend("required", {
  ...required,
  message: "Este campo é obrigatório",
});

export default {
  components: {
    PageTitle,
    Permissions,
    Multiselect,
    "tab-pane": Tab,
    Tabs,
    VueListPicker,
  },
  name: "app",
  data() {
    const rightItems = [];
    const cultures = [];
    return {
      modals: {
        modal0: false,
        modal1: false,
        modal2: false,
        modal3: false,
        modal4: false,
      },
      filter: {},
      channelSelected: {},
      isChannel: {},
      filterRight: {},
      errors: [],
      rightItems: [],
      allcultures: [],
      cultures: [],
      channels: [],
      paginated_data_right: [],
      paginated_data_left: [],
      channel: {},
      culture: {},
      id: "id",
      description: "description",
      NoDelete: null,
    };
  },
  mounted() {
    this.loadPrimaryChannels();
    this.setCultures("left");
    this.filterCultures(null);
  },
  methods: {
    alerta() {
      alert("teste");
    },
    adicionaraochannel: function (channel_id, event) {
      if (event) {
        if (Array.isArray(event)) {
          for (let culture of event) {
            culture.channel_id = channel_id;
            this.$http.secured
              .put(`/api/v1/cultures/${culture.id}`, culture)
              .then((response) => {
                this.response = response.data;
                this.setCultures("left", this.filter);
              })
              .catch((error) => this.setError(error, "Cannot update Culture"));
          }
        } else {
          event.channel_id = channel_id;
          this.$http.secured
            .put(`/api/v1/cultures/${event.id}`, event)
            .then((response) => {
              this.response = response.data;
              this.setCultures("left", this.filter);
            })
            .catch((error) => this.setError(error, "Cannot update Culture"));
        }
      }
    },
    setError(error, text) {
      this.error =
        (error.response && error.response.data && error.response.data.error) ||
        text;
    },
    loadPrimaryChannels() {
      this.$http.secured.get("/api/v1/channels").then((response) => {
        this.channels = response.data;
        this.setCultures("right", this.channels[0].id);
        this.channelSelected = this.channels[0].id;
      });
    },
    loadChannels() {
      this.$http.secured.get("/api/v1/channels").then((response) => {
        this.channels = response.data;
      });
    },
    loadCulturas() {
      this.$http.secured
        .get("/api/v1/cultures", {
          params: {
            page: page,
            q: q,
          },
        })
        .then((response) => {
          if (side === "right") {
            this.paginated_data_right = response.data;
            this.rightItems = this.paginated_data_right["cultures"];
          } else {
            this.paginated_data_left = response.data;
            this.cultures = this.paginated_data_left["cultures"];
          }
        })
        .catch((error) => this.setError(error, "Something went wrong"));
    },
    setCultures(side, q, page, filterRight) {
      // Verifica se a requisição é para o lado direito do quadro
      if (side === "left") {
        // Se veio algo como parametro, sobrescreva
        if (q) {
          q = this.filter;
          // O id 0 significa que a cultura não está vinculada a nenhum segmento
          q.channel_id = 0;
        }
        // Se for do lado direito, o q virá diretamente como o id do channel
      } else {
        console.log(q);
        this.filter.channel_id = q;
        q = this.filter;
      }
      // Se o input de filtro do lado direito for utilizado seta o valor no q
      if (filterRight) {
        q.description = filterRight.description;
      }

      // Parametros vazios não serão consultados
      if (q.description === "") {
        delete q.description;
      }
      //  Adicionando valores default a query e ao número da página se não definidos
      if (typeof page === "undefined") page = null;
      if (typeof q === "undefined" || this.emptyFilter) q = null;

      // Removendo os campos vazios que são passados em pesquisa seguidas de outras
      this.$http.secured
        .get("/api/v1/cultures", {
          params: {
            page: page,
            q: q,
          },
        })
        .then((response) => {
          if (side === "right") {
            this.paginated_data_right = response.data;
            this.rightItems = this.paginated_data_right["cultures"];
          } else {
            this.paginated_data_left = response.data;
            this.cultures = this.paginated_data_left["cultures"];
          }
        })
        .catch((error) => console.warn("[ChannelCulture][setCultures] Culture retrieval error: ", error));
    },
    changePageLeft(page) {
      this.setCultures("left", this.filter, page);
    },
    changePageRight(page) {
      this.setCultures("right", this.channelSelected, page);
    },
    removeAcent(text) {
      text = text.toLowerCase();
      text = text.replace(new RegExp("[ÁÀÂÃ]", "gi"), "a");
      text = text.replace(new RegExp("[ÉÈÊ]", "gi"), "e");
      text = text.replace(new RegExp("[ÍÌÎ]", "gi"), "i");
      text = text.replace(new RegExp("[ÓÒÔÕ]", "gi"), "o");
      text = text.replace(new RegExp("[ÚÙÛ]", "gi"), "u");
      text = text.replace(new RegExp("[Ç]", "gi"), "c");
      text = text.toLowerCase();
      return text;
    },
    save() {
      if (this.isChannel) {
        this.saveChannel();
      } else {
        this.saveCulture();
      }
    },
    edit() {
      if (this.isChannel) {
        this.editChannel();
      } else {
        this.editCulture();
      }
    },
    remove(item) {
      if (this.isChannel) {
        this.removeChannel(item);
      } else {
        this.removeCulture(item);
      }
    },
    saveChannel() {
      this.$http.secured
        .post("/api/v1/channels", { channel: this.channel })
        .then((response) => {
          this.channels.push(response.data);
          this.$toasted.global.defaultSuccess();
          this.loadChannels();
          this.modals.modal0 = false;
          this.channel = {};
        })
        .catch((error) => this.setError(error, "Cannot save Channel"));
    },
    editChannel() {
      this.$http.secured
        .put(`/api/v1/channels/${this.channel.id}`, this.channel)
        .then((response) => {
          this.response = response.data;
          this.$toasted.global.defaultSuccess();
          this.loadChannels();
          this.modals.modal1 = false;
          this.channel = {};
        })
        .catch((error) => this.setError(error, "Cannot update Channel"));
    },
    checkToDelete() {
      if (this.rightItems.length > 0) {
        this.NoDelete = true;
      } else {
        this.NoDelete = false;
      }

    },
    removeChannel(channel) {
      this.checkToDelete();
      if (this.NoDelete == false) {
        if (confirm("Deseja excluir o segmento?")) {
          this.$http.secured
            .delete(`/api/v1/channels/${channel.id}`, channel)
            .then((response) => {
              this.$toasted.global.defaultSuccess();
              this.loadChannels();
              this.$http.secured
                .get(`/api/v1/culturefilter?channel_id=${channel.id}`)
                .then((response) => {
                  if (response.data) {
                    this.adicionaraochannel(0, response.data);
                  }
                });
              this.modals.modal2 = false;
            })
            .catch((error) => this.setError(error, "Cannot delete Channel"));
        }
      } else if (this.NoDelete == true) {
        
        this.$toasted.global.defaultError({msg: 'Não é possivel excluir um segmento com culturas vinculadas!'});
      }
    },
    async saveCulture() {
      const validForm = await this.$refs.culture_observer.validate();
      if (!validForm) {
        console.log("invalid Form");
        return;
      }

      this.$http.secured
        .post("/api/v1/cultures", { culture: this.culture })
        .then((response) => {
          this.$toasted.global.defaultSuccess();
          this.setCultures("left", this.filter);
          this.modals.modal4 = false;
          this.culture = {};
        })
        .catch((error) => this.setError(error, "Cannot save Culture"));
    },
    editCulture() {
      this.culture.description = this.culture.description.toUpperCase();
      this.$http.secured
        .put(`/api/v1/cultures/${this.culture.id}`, this.culture)
        .then((response) => {
          this.response = response.data;
          this.$toasted.global.defaultSuccess();
          this.setCultures("left", this.filter);
          this.modals.modal3 = false;
          this.culture = {};
        })
        .catch((error) => this.setError(error, "Cannot update Culture"));
    },
    removeCulture(culture) {
      if (confirm("Deseja excluir a cultura?")) {
        this.$http.secured
          .delete(`/api/v1/cultures/${culture.id}`, culture)
          .then((response) => {
            this.$toasted.global.defaultSuccess();
            this.setCultures("right", this.filter.id);
          })
          .catch((error) => this.setError(error, "Cannot delete Culture"));
      }
    },
    filterCultures(event) {
      let q = {};
      if (event) {
        q.description = event;
      } else {
        q = null;
      }
      let page = null;
      this.$http.secured
        .get("/api/v1/cultures", {
          params: {
            page: page,
            q: q,
          },
        })
        .then((response) => {
          this.allcultures = response.data["cultures"];
        })
        .catch((error) => this.setError(error, "Something went wrong"));
    },
    editEvent(item) {
      this.culture = item;
      this.modals.modal3 = true;
    },
    searchEventLeft(pesquisa) {
      this.filter.description = pesquisa;
      this.setCultures("left", this.filter, null);
      //setCultures('left', filter, null)
    },
    searchEventRight(pesquisa, channel) {
      this.filterRight.description = pesquisa;
      this.setCultures("right", channel, undefined, this.filterRight);
    },
  },
  computed: {
    emptyFilter: function () {
      for (var key in this.filter) {
        if (
          this.filter.hasOwnProperty(key) &&
          this.filter[key] != "" &&
          typeof this.filter[key] != "undefined"
        ) {
          return false;
        }
      }
      return true;
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.tab-pane {
  padding: 10px;
}
.list-picker-selected {
  background: #61cf8a !important;
}

.button-class {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
  margin-bottom: 10px !important;
  padding-left: 10px !important;
  padding-right: 10px !important;
  min-width: 50% !important;
}

.button-class img {
  filter: invert(100%);
}
.deletSegment{
  margin-bottom: 10px;
}

.list-picker-container {
  border-width: 10px !important;
  border-color: #f6f6f6 !important;
  background-color: #f6f6f6 !important;
  border-radius: 12px !important;
}

.list-picker-panel {
  border: 1px solid;
  border-color: #ccc;
  border-top: 3px solid;
  border-top-color: #61cf8a;
}

.tituloGrupos {
  background-color: #61cf8a !important;
  box-sizing: border-box !important;
  color: rgb(255, 255, 255) !important;
  display: inline-block !important;
  font-family: Roboto, sans-serif !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  height: 30px !important;
  line-height: 17px !important;
  padding-bottom: 4px !important;
  padding-left: 12px !important;
  padding-right: 12px !important;
  padding-top: 7px !important;
  text-align: left !important;
  text-size-adjust: 100% !important;
  visibility: visible !important;
  border-radius: 6px 6px 0px 0px;
  border-bottom: 0px !important;
  width: 100% !important;
}
.inputLeft {
  width: 97%;
}
.inputRight {
  float: right;
  width: 89%;
}
@media (max-width: 768px) {
  .base-pagination-top{
  position: relative;
  margin-top: -680px;
}
}
</style>
